<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      Full Chain报表—查看报表前请确认已同步构建统计数据，否则，请
      <router-link to="/inv/inv" slot="extra">[同步构建统计数据]</router-link>
    </p>
    <template slot="extra"> </template>
    <Row>
      <Col span="24">
        <Select
          v-model="query.category"
          placeholder="请选择Category"
          class="public-inp"
          filterable
          clearable
        >
          <Option
            v-for="item in categoryList"
            :value="item.category"
            :key="item.category"
            >{{ item.category }}
          </Option>
        </Select>
        <Select
          v-model="query.shortName"
          placeholder="请选择ShortName"
          class="public-inp"
          filterable
          clearable
        >
          <Option
            v-for="item in shortNameList"
            :value="item.shortName"
            :key="item.shortName"
            >{{ item.shortName }}
          </Option>
        </Select>
        <DatePicker
          type="date"
          format="yyyy-MM-dd"
          v-model="query.startDate"
          placeholder="请选择起始日期"
          style="width: 200px"
          confirm
          :value="expiredRange"
        ></DatePicker>
        <DatePicker
          type="date"
          format="yyyy-MM-dd"
          v-model="query.endDate"
          placeholder="请选择截止日期"
          style="width: 200px"
          confirm
          :value="expiredRange"
        ></DatePicker>

        <Button
          class="public-fr"
          @click="reset()"
          v-access="'inv.summary.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'inv.summary.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <div class="Echarts">
          <div
            id="main"
            style="width: 100%; height: 400px; margin-top: 30px"
          ></div>
        </div>
        <div style="height: 400px; overflow-y: scroll; overflow-x: hidden">
          <table style="width: 100%; text-align: left">
            <tr>
              <th
                v-for="(item, index) in chartTableHeader"
                :key="index"
                style="height: 50px"
              >
                {{ item }}
              </th>
            </tr>
            <tr
              v-for="(tr, index) in chartTableBody"
              :key="index"
              style="height: 50px"
            >
              <td v-for="(td, i0) in tr" :key="i0">
                {{ td }}
              </td>
            </tr>
          </table>
          <table style="width: 100%; text-align: left">
            <tr>
              <th
                v-for="(item, index) in tableHeader"
                :key="index"
                style="height: 50px"
              >
                {{ item }}
              </th>
            </tr>
            <tr
              v-for="(tr, index) in tableBody"
              :key="index"
              style="height: 50px"
            >
              <td v-for="(td, i0) in tr" :key="i0">
                {{ td }}
              </td>
            </tr>
          </table>
          <table style="width: 100%; text-align: left">
            <tr>
              <th
                v-for="(item, index) in retailDayTableHeader"
                :key="index"
                style="height: 50px"
              >
                {{ item }}
              </th>
            </tr>
            <tr
              v-for="(tr, index) in retailDayTableBody"
              :key="index"
              style="height: 50px"
            >
              <td v-for="(td, i0) in tr" :key="i0">
                {{ td }}
              </td>
            </tr>
          </table>
          <table style="width: 100%; text-align: left">
            <tr>
              <th
                v-for="(item, index) in retailTableHeader"
                :key="index"
                style="height: 50px"
              >
                {{ item }}
              </th>
            </tr>
            <tr
              v-for="(tr, index) in retailTableBody"
              :key="index"
              style="height: 50px"
            >
              <td v-for="(td, i0) in tr" :key="i0">
                {{ td }}
              </td>
            </tr>
          </table>
        </div>
      </Col>
    </Row>
  </Card>
</template>
<script>
export default {
  name: "Echarts",
  data() {
    return {
      expiredRange:'',
      visiable: false,
      open: false,
      query: {
        category: "",
        shortName: "",
        startDate: "",
        endDate: "",
        //date: "",
      },
      isDisabled: false,
      tableHeader: {}, //绑定表头
      tableBody: {}, //绑定数据
      retailTableHeader: {},
      retailTableBody: {},
      retailDayTableHeader: {},
      retailDayTableBody: {},
      chartTableHeader: {},
      chartTableBody: {},
      title: "Inv Days",
      categoryList: [],
      shortNameList: [],
    };
  },
  created() {
    this.getCategoryList();
    this.getShortNameList();
  },
  mounted() {
    //this.myEcharts();
  },
  methods: {
    getCategoryList() {
      this.$api.getInvReportCategoryList({}).then((res) => {
        if (res.code == "200") {
          this.categoryList = res.data;
        }
      });
    },
    getShortNameList() {
      this.$api.getInvReportShortNameList({}).then((res) => {
        if (res.code == "200") {
          this.shortNameList = res.data;
        }
      });
    },
    getList() {
      let startDate = this.tools.formatDate(this.query.startDate, false);
      if (startDate == "") {
        this.$Message.error("请选择报表时间区间！");
        return false;
      }

      let endDate = this.tools.formatDate(this.query.endDate, false);
      if (endDate == "") {
        this.$Message.error("请选择报表时间区间！");
        return false;
      }

      if (this.query.startDate >= this.query.endDate) {
        this.$Message.error("请选择startDate小于endDate的日期区间！");
        return false;
      }

      let params = {
        category: this.query.category,
        shortName: this.query.shortName,
        startDate: startDate,
        endDate: endDate,
      };

      this.$api.getInvReportList(params).then((res) => {
        if (res.code == "200") {
          //第一次遍历，制作 tableHeader
          let th = {};
          th["parameter"] = res.data.name + " ( Tin'000 ) "; //固定列

          //筛选日期
          let thKey = {};
          for (let i = 0; i < res.data.yearMontList.length; i++) {
            thKey[res.data.yearMontList[i]] = 1; //动态列
          }

          //把科目加到th里面 ，动态增加列
          for (let key in thKey) {
            th[key] = key;
          }

          this.tableHeader = th;

          //第二次遍历，制作tr的行
          let tr = {};
          for (let i = 0; i < res.data.invDetails.length; i++) {
            let d = res.data.invDetails[i];
            tr[d.parameter] = {
              parameter: d.parameter, //固定列
            };
          }

          //第三次遍历，添加科目的成绩
          for (let i = 0; i < res.data.invDetails.length; i++) {
            let d = res.data.invDetails[i];
            for (let j = 0; j < d.invItems.length; j++) {
              let item = d.invItems[j];
              tr[d.parameter][item.yearMonth] = item.inv; //动态列
            }
          }

          this.tableBody = tr;
        }
      });

      this.$api.getRetailInvReportList(params).then((res) => {
        if (res.code == "200") {
          this.retailTables(res);
        } else {
          this.$Message.error(res.message);
        }
      });

      this.$api.getRetailInvDaysReportList(params).then((res) => {
        if (res.code == "200") {
          this.retailDayTables(res);
        } else {
          this.$Message.error(res.message);
        }
      });

      this.$api.getSkuChartDataList(params).then((res) => {
        //let dimensions = ['reportDate', 'TTL Chain', 'ELN', 'SP', 'Retailer*', 'Retail POS', 'Transit'];
        if (res.code == "200") {
          let source = [];
          this.title = "[" + res.data[0].name + " Inv Days]";
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];
            source.push({
              reportDate: item.reportDate,
              "TTL Chain": item.ttlChain,
              ELN: item.eln,
              SP: item.sp,
              "Retailer*": item.retailer,
              "Retail POS": item.retailPos,
              Transit: item.transit,
            });
          }

          this.$nextTick(() => {
            this.myEcharts(source);
          });
        } else {
          this.$Message.error(res.message);
        }
      });

      this.$api.getSkuChartTableDataList(params).then((res) => {
        if (res.code == "200") {
          //第一次遍历，制作 tableHeader
          let th = {};
          th["parameter"] = res.data.name + "(Inv Days)"; //固定列

          //筛选日期
          let thKey = {};
          for (let i = 0; i < res.data.yearMontList.length; i++) {
            thKey[res.data.yearMontList[i]] = 1; //动态列
          }

          //把科目加到th里面 ，动态增加列
          for (let key in thKey) {
            th[key] = key;
          }

          this.chartTableHeader = th;

          //第二次遍历，制作tr的行
          let tr = {};
          for (let i = 0; i < res.data.invDetails.length; i++) {
            let d = res.data.invDetails[i];
            tr[d.parameter] = {
              parameter: d.parameter, //固定列
            };
          }

          //第三次遍历，添加科目的成绩
          for (let i = 0; i < res.data.invDetails.length; i++) {
            let d = res.data.invDetails[i];
            for (let j = 0; j < d.invItems.length; j++) {
              let item = d.invItems[j];
              tr[d.parameter][item.yearMonth] = item.inv; //动态列
            }
          }

          this.chartTableBody = tr;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    reset() {
      this.query.category = "";
      this.query.shortName = "";
      this.query.endDate = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str);
    },
    myEcharts(source) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("main"));

      // 指定图表的配置项和数据
      let option = {
        title: {
          text: this.title,
        },
        tooltip: {},
        legend: {},
        dataset: {
          // 提供一份数据。
          dimensions: [
            "reportDate",
            "ELN",
            "SP",
            "Retailer*",
            "Retail POS",
            "Transit",
          ],
          source: source,
        },
        xAxis: {
          type: "category",
        },
        yAxis: [
          {
            type: "value",
            position: "left",
          },
          {
            type: "value",
            name: "POS Tin'000",
            position: "right",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          // {
          //   name: 'TTL Chain',
          //   type: 'line',
          //   stack: 'x',
          //   smooth: true
          // },
          {
            name: "ELN",
            type: "bar",
            stack: "x",
            yAxisIndex: 0,
          },
          {
            name: "SP",
            type: "bar",
            stack: "x",
            yAxisIndex: 0,
          },
          {
            name: "Retailer",
            type: "bar",
            stack: "x",
            yAxisIndex: 0,
          },
          {
            name: "Retail POS",
            type: "line",
            // stack: 'x',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: "top",
            },
          },
          {
            name: "Transit",
            type: "bar",
            stack: "x",
            yAxisIndex: 0,
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    chartTables(data) {
      //第一次遍历，制作 tableHeader
      let th = {};
      th["parameter"] = data.name; //固定列

      //筛选日期
      let thKey = {};
      for (let i = 0; i < data.yearMontList.length; i++) {
        thKey[data.yearMontList[i]] = 1; //动态列
      }

      //把科目加到th里面 ，动态增加列
      for (let key in thKey) {
        th[key] = key;
      }

      this.chartTableHeader = th;

      //第二次遍历，制作tr的行
      let tr = {};
      for (let i = 0; i < data.invDetails.length; i++) {
        let d = data.invDetails[i];
        tr[d.parameter] = {
          parameter: d.parameter, //固定列
        };
      }

      //第三次遍历，添加科目的成绩
      for (let i = 0; i < data.invDetails.length; i++) {
        let d = data.invDetails[i];
        for (let j = 0; j < d.invItems.length; j++) {
          let item = d.invItems[j];
          tr[d.parameter][item.yearMonth] = item.inv; //动态列
        }
      }

      this.chartTableBody = tr;
    },
    retailTables(res) {
      //第一次遍历，制作 tableHeader
      let th = {};
      th["parameter"] = "Retail Inv(Tin'000)"; //固定列

      //筛选日期
      let thKey = {};
      for (let i = 0; i < res.data.yearMontList.length; i++) {
        thKey[res.data.yearMontList[i]] = 1; //动态列
      }

      //把科目加到th里面 ，动态增加列
      for (let key in thKey) {
        th[key] = key;
      }

      this.retailTableHeader = th;

      //第二次遍历，制作tr的行
      let tr = {};
      for (let i = 0; i < res.data.invDetails.length; i++) {
        let d = res.data.invDetails[i];
        tr[d.parameter] = {
          parameter: d.parameter, //固定列
        };
      }

      //第三次遍历，添加科目的成绩
      for (let i = 0; i < res.data.invDetails.length; i++) {
        let d = res.data.invDetails[i];
        for (let j = 0; j < d.invItems.length; j++) {
          let item = d.invItems[j];
          tr[d.parameter][item.yearMonth] = item.inv; //动态列
        }
      }

      this.retailTableBody = tr;
    },
    retailDayTables(res) {
      //第一次遍历，制作 tableHeader
      let th = {};
      th["parameter"] = "Inv Days"; //固定列

      //筛选日期
      let thKey = {};
      for (let i = 0; i < res.data.yearMontList.length; i++) {
        thKey[res.data.yearMontList[i]] = 1; //动态列
      }

      //把科目加到th里面 ，动态增加列
      for (let key in thKey) {
        th[key] = key;
      }

      this.retailDayTableHeader = th;

      //第二次遍历，制作tr的行
      let tr = {};
      for (let i = 0; i < res.data.invDetails.length; i++) {
        let d = res.data.invDetails[i];
        tr[d.parameter] = {
          parameter: d.parameter, //固定列
        };
      }

      //第三次遍历，添加科目的成绩
      for (let i = 0; i < res.data.invDetails.length; i++) {
        let d = res.data.invDetails[i];
        for (let j = 0; j < d.invItems.length; j++) {
          let item = d.invItems[j];
          tr[d.parameter][item.yearMonth] = item.inv; //动态列
        }
      }

      this.retailDayTableBody = tr;
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}

body {
  font: normal 11px auto "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
  color: #4f6b72;
  background: #e6eae9;
}

a {
  color: #c75f3e;
}

#mytable {
  width: 700px;
  padding: 0;
  margin: 20px;
}

caption {
  padding: 0 0 5px 0;
  width: 700px;
  font: italic 11px "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
  text-align: right;
}

th {
  font: bold 11px "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
  color: #4f6b72;
  border-right: 0px solid #c1dad7;
  border-bottom: 1px solid #c1dad7;
  border-top: 1px solid #c1dad7;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-align: left;
  padding: 6px 6px 6px 12px;
  background: #cae8ea no-repeat;
}

th.nobg {
  border-top: 0;
  border-left: 0;
  border-right: 1px solid #c1dad7;
  background: none;
}

td {
  border-right: 1px solid #c1dad7;
  border-bottom: 1px solid #c1dad7;
  background: #fff;
  font-size: 11px;
  padding: 6px 6px 6px 12px;
  color: #4f6b72;
}

td.alt {
  background: #f5fafa;
  color: #797268;
}

th.spec {
  border-left: 1px solid #c1dad7;
  border-top: 0;
  background: #fff no-repeat;
  font: bold 10px "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
}

th.specalt {
  border-left: 1px solid #c1dad7;
  border-top: 0;
  background: #f5fafa no-repeat;
  font: bold 10px "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
  color: #797268;
}

/*---------for IE 5.x bug*/
html > body td {
  font-size: 11px;
}

body,
td,
th {
  font-family: 宋体, Arial;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/invreport/summary.vue